import React from 'react';
import { useEffect, useState } from "react";
import { getAllData, } from '../../../services/ApiCallingUserServices';
import { formatDate, generatePDF } from '../../commonClass/CommonValidation'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, GetLocalStorage } from '../../commonClass/Session';
import { useDispatch, useSelector } from "react-redux";
import { loaderActions } from "../../../_actions/loader.actions";
import { ExportExcel } from '../../commonClass/ExportExcel';
import CustomTable from "../../../customControl/CustomTable";
import CommonFilter from '../../../customControl/CommonFilter';


const Packagelistmaster = () => {
    //#region declartion of variable
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [packagedata, setPackageData] = useState([]);
    const [searchvalue, setSearchValue] = useState();
    const [searchby, setSerachBy] = useState('All');
    const [filteritems, setFilterItems] = useState([]);

    const user = useSelector(store => store.userstatus.tba);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);
    const [userexport, setUserExport] = useState(true);

    //#endregion

    //#region  use effect section
    useEffect(() => {
        dispatch(loaderActions.start());
        let token = GetLocalStorage();
        if (token && token.userName && token.token) {
            getPackageDataList().then(() => { dispatch(loaderActions.end()) });;
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
    }, [])

    useEffect(() => {
        let pagelink = user?.find(x => {
            if (x.PageLink === window.location.pathname)
                return x.MenuId
        });
        let mid = user?.find(x => x.MenuId === pagelink.MenuId);
        if (mid?.URightView === false && mid?.URightView !== undefined) {
            navigate('/dashboard');
        }
        user?.filter(x => x.MenuId === pagelink.MenuId).map((obj) => {
            setUserAdd(obj.URightAdd);
            setUserEdit(obj.URightEdit);
            setUserExport(obj.URightExport);

        });
    }, [user])
    //#endregion

    //#region fill dropdown and handle input value
    const getPackageDataList = async () => {
        dispatch(loaderActions.start());
        const packagedata = await getAllData("/master/v1/getallpackage");
        packagedata?.data?.forEach((obj) => {
            obj.Active = obj.IsActive ? 'Active' : 'InActive'
            obj.StateName = obj?.StateName === '-' ? '' : obj?.StateName
            obj.CreatedDateFormat = formatDate(obj?.CreatedOn);
        })
        setPackageData(packagedata?.data);
        setFilterItems(packagedata?.data);
        dispatch(loaderActions.end());
    }

    //#endregion

    //#region table Pagination
    const columns = [
        {
            name: 'Sr No.',
            key: 'SeqNo',
            isSearch: false,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.SeqNo
        },
        {
            name: 'Country',
            key: 'CountryName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.CountryName
        },
        {
            name: 'State',
            key: 'StateName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.StateName
        },
        {
            name: 'Package Name',
            key: 'PackageName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.PackageName
        },
        {
            name: 'Package Code',
            key: 'PackageCode',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.PackageCode
        },
        {
            name: 'Package Type',
            key: 'PackageTypeName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.PackageTypeName
        },
        {
            name: 'Package Level',
            key: 'PackageLevelName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.PackageLevelName
        },
        {
            name: 'Package Category',
            key: 'PackageCategoryName',
            isSearch: true,
            sortable: true,
            float: "left",
            reorder: true,
            selector: (pack) => pack.PackageCategoryName
        },
        {
            name: 'Active',
            key: 'Active',
            isSearch: true,
            sortable: true,
            float: "left",
            selector: (pack) => pack.Active
        },
        {
            name: 'Created Date',
            key: 'CreatedDateFormat',
            isSearch: false,
            sortable: true,
            float: "left",
            selector: (pack) => new Date(pack.CreatedOn),
            format: (pack) => pack.CreatedDateFormat,
        },
        {
            name: 'Edit',
            selector: (pack) => <button type='button' className='border-0 p-0 bg-body set_disableclr' disabled={!useredit}><i className="fa fa-edit" onClick={() => handleEditPackage(pack)}></i></button>
        },
        {
            name: 'View',
            selector: (pack) => <i className="fa fa-eye" onClick={() => handleViewPackage(pack.PackageId)}></i>
        }
    ];

    //#endregion

    const handleOpenPackage = () => {
        navigate('/Packagedetail', { state: { disabled: false, editdisabled: false, viewtype: 'Add', PackageId: 0, atfirstdisable: true } });
    }

    const handleEditPackage = (pack) => {
        dispatch(loaderActions.start())
        navigate('/Packagedetail', { state: { disabled: false, editdisabled: true, viewtype: 'Update', PackageId: pack.PackageId, atfirstdisable: false, IsDraft: pack.IsDraft } });
    }

    const handleViewPackage = (id) => {
        dispatch(loaderActions.start())
        navigate('/Packagedetail', { state: { disabled: true, editdisabled: true, viewtype: 'View', PackageId: id, atfirstdisable: false } });
    }

    function PdfExport() {
        const keys = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        const pdfColumns = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const rows = packagedata?.map((obj) => keys?.map((key) => obj[key]));
        generatePDF(pdfColumns, rows, "ETMPackageMaster", "ETM Package Master", 'l')
    }

    const ExportToExcel = () => {
        const dispalyname = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.name);
        const fields = columns?.filter((obj) => (obj?.key && !obj.omit))?.map((obj) => obj.key);
        ExportExcel(dispalyname, fields, packagedata, "PackageMaster", "PackageCreation.xls");

    }

    return (
        <>
            <div className="container-fluid mt-4 heading_color">
                <h3>ETM Package List</h3>
            </div>
            <div className="container-fluid form_border py-5 my-3">
                <form action="" >
                    <div className="d-flex justify-content-start ms-lg-3">
                        <button disabled={!useradd} type="button" className="btn btn-primary mx-1" to="Packagemaster" id="btnAdd"
                            onClick={handleOpenPackage}
                        >Create New Package</button>
                    </div>
                    <br />
                    <CommonFilter
                        columns={columns}
                        filterList={filteritems}
                        searchDisabled={false}
                        getdata={getPackageDataList}
                        setlistdata={setPackageData}
                        searchvalue={searchvalue}
                        setSearchValue={setSearchValue}
                        searchby={searchby}
                        setSerachBy={setSerachBy}
                    />

                    <CustomTable
                        columns={columns}
                        data={packagedata}
                        PdfExport={PdfExport}
                        ExportToExcel={ExportToExcel}
                        disabled={!userexport}
                    />

                </form>
            </div>
        </>
    )
}

export default Packagelistmaster
